import {AVAILABLE_CSV_DELIMITERS, DEFAULT_CSV_DELIMITERS} from "../constants";

export namespace nsCsv {

    export interface IParsedCsv {
        headings: string[]
        rows: string[][]
    }

    export type TDelimiter = typeof AVAILABLE_CSV_DELIMITERS[number]

    /**
     * Takes a CSV string that is seperated by semicolon (or other delimiter) and returns an array with values.
     * @param row
     * @param delimiter
     */
    export function parseRow(row: string, delimiter: TDelimiter = ";"): string[] {

        let ret: string[]
        let str = row.trim()
        const a = str.startsWith('"');
        const b = str.endsWith('"');
        const c = str.endsWith(`"${delimiter}`);
        const valuesAreEnclosedWithDoubleQuotes = a && (b || c);

        // Split
        if (valuesAreEnclosedWithDoubleQuotes) {
            const regExStr = `((?<=${delimiter}|^})|(".*?"))(?=${delimiter}|$)`
            const regex = new RegExp(regExStr, 'g')
            ret = str
                .match(regex)?.map((s) => {
                    // remove enclosing double quotes
                    if (s.startsWith('"') && s.endsWith('"')) {
                        s = s.substring(1, s.length - 1)
                    }
                    // Replace pairs of double quotes
                    s = s.replace(/""/g, '"')
                    return s
                }) ?? []
        } else {
            ret = row.split(delimiter)
        }
        return ret
    }

    export function parseCsv(csv: string, delimiter: TDelimiter = DEFAULT_CSV_DELIMITERS): IParsedCsv {
        const _rows = csv
            .split(/\r?\n/gm)
            .filter(row => row.trim())
            .map(row => parseRow(row, delimiter))

        const ret: IParsedCsv = {
            headings: _rows[0] ?? [],
            rows: _rows.slice(1),
        }
        return ret
    }

}